import WizardContent from '../components/wizard/WizardContent';
import Direction from "../components/wizard/Direction.vue";
import TypeApartment from "../components/wizard/TypeApartment.vue";
import Occupied from "../components/wizard/Occupied.vue";
import GroundFloor from "../components/wizard/GroundFloor.vue";
import Size from "../components/wizard/Size.vue";
import Features from "../components/wizard/Features.vue";
import Status from "../components/wizard/State.vue";
import SaleStatus from "../components/wizard/SaleState.vue";
import Burdened from "../components/wizard/Burdened.vue";
import PersonalForm from "../components/wizard/PersonalForm.vue";
import Comfirm from "../components/wizard/Comfirm.vue";

const routes =
{
    path: "/simular-inversion",
    component: WizardContent,
    children: [
        {
            path: "direccion",
            name: "Direction",
            component: Direction,
            stepName: 'Consigue una oferta por tu vivienda'
        },
        {
            path: "tipo-vivienda",
            name: "typeApartment",
            component: TypeApartment,
            stepName: 'Tipo de casa'
        },
        {
            path: "tamano",
            name: "Size",
            component: Size,
            stepName: 'Tamaño'
        },
        {
            path: "planta",
            name: "GroundFloor",
            component: GroundFloor,
            stepName: 'Planta'
        },
        {
            path: "ocupado",
            name: "Occupied",
            component: Occupied,
            stepName: 'Ocupado'
        },
        {
            path: "caracteristicas",
            name: "Features",
            component: Features,
            stepName: 'Características'
        },
        {
            path: "estado-vivienda",
            name: "State",
            component: Status,
            stepName: 'Estado vivienda'
        },
        {
            path: "estado-de-venta",
            name: "SaleState",
            component: SaleStatus,
            stepName: 'Estado de venta'
        },
        {
            path: "libre-de-cargas",
            name: "Burdened",
            component: Burdened,
            stepName: '¿La casa está libre de cargas?'
        },
        {
            path: "datos-personales",
            name: "PersonalForm",
            component: PersonalForm,
            stepName: 'datos-personales'
        },
        {
            path: "final",
            name: "Confirm",
            component: Comfirm,
            stepName: 'final'
        }
    ]
};

let cookieDirection = document.cookie.indexOf('directionValue') > -1 ? 'typeApartment' : 'Direction';

for (let route of routes.children) {
    if (route.name !== cookieDirection) {
        route.beforeEnter = (to, from, next) => {
            if (!from.name) {
                return next({ name: cookieDirection });
            }
            next();
        }
    }
}

export default routes;
